(() => {
  const roleOf = (item, configuration) => {
    if (item.product_id === configuration.wrapProductId) return 'wrap';
    if (item.product_id === configuration.materialsProductId) return 'materials';
    if (configuration.miniProductIds.includes(item.product_id)) return 'mini';
    return 'normal';
  };

  const lineQuantities = (cart, configuration) => {
    const state = { normal: 0, wrap: 0, materials: 0, mini: 0, wrapLines: [], materialLines: [], miniLines: [] };
    for (const item of cart.items) {
      const role = roleOf(item, configuration);
      state[role] += item.quantity;
      if (role === 'wrap') state.wrapLines.push(item);
      if (role === 'materials') state.materialLines.push(item);
      if (role === 'mini') state.miniLines.push(item);
    }
    return state;
  };

  const usableCandidate = (candidate) => candidate && candidate.price === 0 && candidate.available && candidate.tracked && candidate.denyOverselling && candidate.inventory > 0;
  const limit = (value) => Math.max(0, Math.floor(Number(value) || 0));

  const correctionsFor = (cart, configuration, preferredType = null) => {
    const state = lineQuantities(cart, configuration);
    const updates = {};
    const assign = (item, quantity) => { if (quantity !== item.quantity) updates[item.key] = quantity; };
    if (state.normal === 0) {
      [...state.wrapLines, ...state.materialLines, ...state.miniLines].forEach(item => assign(item, 0));
      return updates;
    }

    const both = state.wrap > 0 && state.materials > 0;
    let wrapRemaining = both && preferredType === 'materials' ? 0 : 1;
    let materialRemaining = both && preferredType !== 'materials' ? 0 : state.normal;
    for (const item of state.wrapLines) {
      const quantity = Math.min(item.quantity, wrapRemaining);
      assign(item, quantity);
      wrapRemaining -= quantity;
    }
    for (const item of state.materialLines) {
      const quantity = Math.min(item.quantity, materialRemaining);
      assign(item, quantity);
      materialRemaining -= quantity;
    }

    let totalRemaining = configuration.miniEnabled ? limit(configuration.maxTotal) : 0;
    const usedByProduct = new Map();
    for (const item of state.miniLines) {
      const candidate = configuration.candidates.find(entry => entry.productId === item.product_id && entry.variantId === item.variant_id);
      const used = usedByProduct.get(item.product_id) || 0;
      const available = usableCandidate(candidate) && item.original_price === 0
        ? Math.max(0, Math.min(limit(configuration.maxPerGift), limit(candidate.inventory)) - used) : 0;
      const quantity = Math.min(item.quantity, totalRemaining, available);
      assign(item, quantity);
      totalRemaining -= quantity;
      usedByProduct.set(item.product_id, used + quantity);
    }
    return updates;
  };

  window.hugcoffeeCartGiftRules = { roleOf, lineQuantities, correctionsFor, usableCandidate };
})();
